export type LightMode = number // 键盘灯光对应的按键值

export enum LightModeType {
  None = -1, //"无",
  RGB = 0, //"幻彩灯效",
  REACT, //"相应灯效",
  MUSIC, //"音乐律动",
  Custom, // "自定义灯效",
  Side, // 侧灯位
}

export interface lightAndName {
  mode: number
  name: string
}

export enum LightDirectionType {
  //从上到下
  up = 'up',
  //从下到上
  down = 'down',
  //从左到右
  left = 'left',
  //从右到左
  right = 'right',
  //从里到外
  inner = 'inner',
  //从外到里
  outer = 'outer',
  // 顺时针
  clockwise = 'clockwise',
  // 逆时针
  counterclockwise = 'counterclockwise',

  // 顺时针
  clockwise_jtv2 = 'clockwise_jtv2',
  // 逆时针
  counterclockwise_jtv2 = 'counterclockwise_jtv2',

  outer_jtv2 = 'outer_jtv2',
  inner_jtv2 = 'inner_jtv2',
  up_jtv2 = 'up_jtv2',
  down_jtv2 = 'down_jtv2',
  left_jtv2 = 'left_jtv2',
  right_jtv2 = 'right_jtv2',
  up_1 = 'up_1',
  down_2 = 'down_2',
}

export const DirectionList: { [index: string]: number } = {
  up: 2,
  down: 3,
  left: 1,
  right: 0,
  inner: 4,
  outer: 5,
  clockwise: 0,
  counterclockwise: 1,
  clockwise_jtv2: 1,
  counterclockwise_jtv2: 0,
  inner_jtv2: 1,
  outer_jtv2: 0,
  up_jtv2: 0,
  down_jtv2: 1,
  left_jtv2: 0,
  right_jtv2: 1,
  up_1: 1,
  down_2: 0,
}
export enum LightColorType {
  //前景色
  foreground,
  //背景色
  background,
}

export interface LightEffect {
  LightColor: LightColorType[]
  isNeon: boolean
  isBrightness: boolean
  isSpeed: boolean
  lightEffectType: LightModeType
  LightDirection: LightDirectionType[]
  imageName: string
}

export type LightEffectModeType = string | LightEffectMode
export enum LightEffectMode {
  Close = '关闭',
  Static = '常亮',
  Breathing = '呼吸',
  Breathing_1 = '呼吸_1',
  Breathing_2 = '呼吸_2',
  Breathing_3 = '呼吸_3',
  Breathing_nd68 = '呼吸_nd68',
  RainbowDream = '梦幻彩虹',
  RainbowDream_jtv2 = '梦幻彩虹_jtv2',
  RainWalk = '雨中散步',
  RainbowWheel = '彩虹轮盘',
  StarryNight = '繁星点点',
  FlowingStream = '川流不息',
  WaveMotion = '随波逐流',
  SineWave = '正弦光波',
  SineWave_jtv2 = '正弦光波_jtv2',
  Scanning = '左右扫描',
  SpinningWindmill = '旋转风车',
  SevenColorWaterfall = '七彩瀑布',
  SevenColorWaterfall_jtv2 = '七彩瀑布_jtv2',
  Prosperity = '花开富贵',
  Prosperity_White = '花开富贵_White',
  Prosperity_nd68 = '花开富贵_nd68',
  Prosperity_jtv2 = '花开富贵_jtv2',
  Prosperity_FE87 = '花开富贵_FE87',
  Prosperity_mg63 = '花开富贵_mg63',
  SpinningStorm = '旋转风暴',
  Collision = '来回碰撞',
  InstantFlash = '一触即发',
  InstantFlash_jtv2 = '一触即发_jtv2',
  InstantFlash_mg63 = '一触即发_mg63',
  KeyRipple = '按键涟漪',
  KeyRipple_jtv2 = '按键涟漪_jtv2',
  ShadowChase = '如影随形',
  SnowTrace = '踏雪无痕',
  Starry = '繁星',
  Starry_jtv2 = '繁星_jtv2',
  CrossFlow = '纵横',
  CloudFlow = '流云',
  MusicValley = '音谷',

  Starry_Brightness = '繁星_Brightness',
  CrossFlow_Brightness = '纵横_Brightness',
  CloudFlow_Brightness = '流云_Brightness',
  MusicValley_Brightness = '音谷_Brightness',

  MusicStarry_jtv2 = '繁星_MusicJtv2',
  MusicCrossFlow_jtv2 = '纵横_jtv2',
  MusicCloudFlow_jtv2 = '流云_jtv2',
  MusicValley_jtv2 = '音谷_jtv2',

  Custom = '自定义',
  Custom_light = '自定义_Light', // 可以调节亮度的自定义
  Neon = '霓虹',
  RainCurtain = '雨落珠帘',
  RainbowWaterfall = '彩虹瀑布',
  RainbowWaterfall_nd68 = '彩虹瀑布_nd68',
  Monochrome = '单色',
  VerticalGradient = '上下渐变',
  TransparentGradient = '透明渐变',
  BreathingRhythm = '呼吸律动',
  BreathingRhythm_nd68 = '呼吸律动_nd68',
  SaturatedStyle = '饱和风采',
  BrightBeauty = '亮度之美',
  SaturatedWindmill = '饱和风车',
  BrightWindmill = '亮度风车',
  SaturatedSpiral = '饱和螺旋',
  BrightSpiral = '亮度螺旋',
  AllCycle = '循环所有',
  HorizontalCycle = '左右循环',
  HorizontalCycle_nd68 = '左右循环_nd68',
  HorizontalCycle_jtv2 = '左右循环_jtv2',
  HorizontalCycle_White = '左右循环_White',
  VerticalCycle = '上下循环',
  RainbowCluster = '彩虹簇辉',
  RainbowCluster_jtv2 = '彩虹簇辉_jtv2',
  InnerOuterCycle = '外内循环',
  BidirectionalCycle = '双向循环',
  WindmillCycle = '风车循环',
  SpiralCycle = '螺旋循环',
  SpiralCycle_mg63 = '螺旋循环_mg63',
  DoubleBeacon = '双信标',
  DoubleBeacon_White = '双信标_White',
  RainbowBeacon = '彩虹信标',
  RainbowBeacon_jtv2 = '彩虹信标_jtv2',
  RainbowWindmill = '彩虹风车',
  Raindrop = '雨滴',
  CandyRaindrop = '糖果雨滴',
  CandyRaindrop_jtv2 = '糖果雨滴_jtv2',
  HueBreathing = '色调呼吸',
  HueBreathing_mg63 = '色调呼吸_mg63',
  HuePendulum = '色调摆钟',
  HueWave = '色调波动',
  HueWave_nd68 = '色调波动_nd68',
  HueWave_1 = '色调波动_1',
  PixelRain = '像素雨',
  PixelFlow = '像素流',
  PixelFlow_nd68 = '像素流_nd68',
  PixelFractal = '像素分形',
  TypingHeatmap = '打字热图',
  SimpleResponse = '简单响应',
  GeneralResponse = '一般响应',
  WideResponse = '宽响应',
  MultiWideResponse = '多宽响应',
  CrossResponse = '十字响应',
  MultiCross = '多十字',
  CenterResponse = '中心响应',
  MultiCenter = '多中心',
  Splash = '飞溅',
  MultiSplash = '多重飞溅',
  FastRainbowDream_1 = '梦幻彩虹_1',
  Static_1 = '常亮_1',
  Static_2 = '常亮_2',
  Static_pro = '常亮_pro',
  Neon_1 = '霓虹_1',
  Wave = '波浪',
  Wave_nd68 = '波浪_nd68',
  Starry_1 = '繁星_1',
  Radar = '雷达',
  HorseRace = '跑马',
  HorseRace_nd68 = '跑马_nd68',
  Ripple = '涟漪',
  MultiLineRace = '多行跑马',
  Laser = '激光',
  RippleAutoPlay = '自动播放涟漪',
  ClickHighlight = '单击亮',
  ClickHighlight_nd68 = '单击亮_nd68',
  ClickHighlight_jtv2 = '单击亮_jtv2',
  CrossCursor = '十字光标',
  Fireworks = '烟花',
  KeystrokeRate = '按键速率响应',
  CustomMode = '客制化模式',
  SixLineRace = '六行跑马',
  MusicRhythm = '音乐律动',
  StaticBright = '静态恒亮',
  StaticBright_White = '静态恒亮_White',
  DynamicBreathing = '动态呼吸',
  SpectrumCycle = '光谱循环',
  Wave_2 = '波浪_2',
  Wave_jingtaiV2 = '波浪_jtv2',
  Wave_mg63 = '波浪_mg63',
  Prosperity_1 = '花开富贵_1',
  PixelFlow_1 = '像素流_1',
  SineWave_1 = '正弦光波_1',
  SineWave_mg63 = '正弦光波_MG63',
  RainbowDream_2 = '梦幻彩虹_2',
  RainbowDream_mg63 = '梦幻彩虹_mg63',
  RainWalk_1 = '雨中散步_1',
  SpinningWindmill_1 = '旋转风车_1',
  SpinningWindmill_nd68 = '旋转风车_nd68',
  SpinningWindmill_jtv2 = '旋转风车_jtv2',
  SpinningWindmill_white = '旋转风车_white',
  StarryNight_1 = '繁星点点_1',
  RainbowWheel_1 = '彩虹轮盘_1',
  WaveMotion_1 = '随波逐流_1',
  SevenColorWaterfall_1 = '七彩瀑布_1',
  Starry_2 = '繁星_2',
  Scanning_1 = '左右扫描_1',
  Scanning_2 = '左右扫描_2',
  Scanning_mg63 = '左右扫描_mg63',
  Collision_2 = '来回碰撞_2',
  SaturatedStyle_pro = '波浪_pro',
  BreathingRhythm_pro = '呼吸律动_pro',
  BreathingRhythm_jtv2 = '呼吸律动_jtv2',
  BreathingRhythm_mg63 = '呼吸律动_mg63',
  RainbowCluster_pro = '彩虹簇辉_pro',
  RainbowBeacon_pro = '彩虹信标_pro',
  HorizontalCycle_pro = '左右循环_pro',
  CandyRaindrop_pro = '糖果雨滴_pro',
  CandyRaindrop_huochairen = '糖果雨滴_火柴人',
  ClickHighlight_pro = '单击亮_pro',
  xx8 = 'xx8',
  xx9 = 'xx9',
  KeyRipple_pro = '按键涟漪_pro',
  KeyRipple_mg63 = '按键涟漪_mg63',
  ShadowChase_pro = '烟花_pro',
  ShadowChase_jtv2 = '烟花_jtv2',
  InstantFlash_pro = '一触即发_pro',

  SideStatic = '常亮_side',
  SideFleeting = '流光_side',
  SideSpectrumCycle = '光谱循环_side',
  SideBreathing = '呼吸_side',
  SideWave = '波浪_side',
  SideCustom = '自定义_side',

  SideClose = '关闭_side',
  SideWave_RA68 = '波浪_side_ra68',
  SideWave_RA68_1 = '波浪_side_ra68_1',
  SideNeon = '霓虹_side',
  SideHorseRace = '跑马_side',
  SideBreathing_RA68 = '呼吸_side_ra68',
  SideBreathing_RA68_1 = '呼吸_side_ra68_1',
  SideFleeting_RG68_1 = '流光_side_ra68_1',
  SaturatedStyle_FE87 = '波浪_fe87',
  SideStatic_RA68_1 = '常亮_side_ra68_1',

  Wave_White = '波浪_White ',
  RainCurtain_White = '雨落珠帘_White',
  RainbowBeacon_White = '彩虹信标_White',

  Fleeting_White = '流光_White',
  Breathing_White = '呼吸_White',
  Waterfall_White = '瀑布_White',
}

export const lightModuleList: { [key: LightEffectModeType]: LightEffect } = {
  [LightEffectMode.Close]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: false,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '关闭',
  },
  [LightEffectMode.Static]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '常亮',
  },
  [LightEffectMode.Breathing]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '呼吸',
  },
  [LightEffectMode.Breathing_1]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: false,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '呼吸_1',
  },
  [LightEffectMode.Breathing_nd68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '呼吸_nd68',
  },
  [LightEffectMode.Breathing_2]: {
    LightColor: [],
    LightDirection: [],
    isNeon: true,
    isBrightness: false,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '呼吸_2',
  },
  [LightEffectMode.Breathing_3]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: false,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '呼吸_3',
  },
  [LightEffectMode.Breathing_White]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '呼吸_3',
  },
  [LightEffectMode.RainbowDream]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: false,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '梦幻彩虹',
  },
  [LightEffectMode.RainbowDream_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.up_jtv2, LightDirectionType.down_jtv2],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '梦幻彩虹',
  },
  [LightEffectMode.RainWalk]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '雨中散步',
  },
  [LightEffectMode.RainbowWheel]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹轮盘',
  },
  [LightEffectMode.StarryNight]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '繁星点点',
  },
  [LightEffectMode.FlowingStream]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '川流不息',
  },
  [LightEffectMode.WaveMotion]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '随波逐流',
  },
  [LightEffectMode.SineWave]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '正弦光波',
  },
  [LightEffectMode.SineWave_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.left, LightDirectionType.right],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '正弦光波',
  },
  [LightEffectMode.Scanning]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '左右扫描',
  },
  [LightEffectMode.SpinningWindmill]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '旋转风车',
  },
  [LightEffectMode.SevenColorWaterfall]: {
    LightColor: [],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '七彩瀑布',
  },
  [LightEffectMode.SevenColorWaterfall_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.up, LightDirectionType.down],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '七彩瀑布',
  },
  [LightEffectMode.Prosperity]: {
    LightColor: [],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '花开富贵',
  },
  [LightEffectMode.Prosperity_White]: {
    LightColor: [],
    LightDirection: [LightDirectionType.inner_jtv2, LightDirectionType.outer_jtv2],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '花开富贵',
  },
  [LightEffectMode.Prosperity_nd68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '花开富贵',
  },
  [LightEffectMode.Prosperity_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.inner_jtv2, LightDirectionType.outer_jtv2],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '花开富贵',
  },
  [LightEffectMode.SpinningStorm]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '旋转风暴',
  },
  [LightEffectMode.Collision]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '来回碰撞',
  },
  [LightEffectMode.InstantFlash]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '一触即发',
  },
  [LightEffectMode.InstantFlash_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.REACT,
    imageName: '一触即发',
  },
  [LightEffectMode.InstantFlash_mg63]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '一触即发',
  },
  [LightEffectMode.KeyRipple]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '按键涟漪',
  },
  [LightEffectMode.KeyRipple_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.REACT,
    imageName: '按键涟漪',
  },
  [LightEffectMode.ShadowChase]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '如影随形',
  },
  [LightEffectMode.SnowTrace]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '踏雪无痕',
  },
  [LightEffectMode.Starry]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: false,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '繁星',
  },
  [LightEffectMode.Starry_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.up, LightDirectionType.down],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '繁星',
  },
  [LightEffectMode.CrossFlow]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: false,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '纵横',
  },
  [LightEffectMode.CloudFlow]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: false,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '流云',
  },
  [LightEffectMode.MusicValley]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: false,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '音谷',
  },
  [LightEffectMode.Starry_Brightness]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: false,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '繁星',
  },
  [LightEffectMode.CrossFlow_Brightness]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: false,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '纵横',
  },
  [LightEffectMode.CloudFlow_Brightness]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: false,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '流云',
  },
  [LightEffectMode.MusicValley_Brightness]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: false,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '音谷',
  },
  [LightEffectMode.MusicStarry_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '繁星',
  },
  [LightEffectMode.MusicCrossFlow_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '纵横',
  },
  [LightEffectMode.MusicCloudFlow_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '流云',
  },
  [LightEffectMode.MusicValley_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '音谷',
  },
  [LightEffectMode.Custom]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: false,
    isSpeed: false,
    lightEffectType: LightModeType.Custom,
    imageName: '自定义',
  },
  [LightEffectMode.Custom_light]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.Custom,
    imageName: '自定义',
  },
  [LightEffectMode.Waterfall_White]: {
    LightColor: [],
    LightDirection: [LightDirectionType.up_1, LightDirectionType.down_2],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '瀑布',
  },
  [LightEffectMode.RainCurtain]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '雨落珠帘',
  },
  [LightEffectMode.RainbowWaterfall]: {
    LightColor: [],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹瀑布',
  },
  [LightEffectMode.RainbowWaterfall_nd68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹瀑布',
  },
  [LightEffectMode.Monochrome]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '单色',
  },
  [LightEffectMode.VerticalGradient]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '上下渐变',
  },
  [LightEffectMode.TransparentGradient]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '透明渐变',
  },
  [LightEffectMode.BreathingRhythm]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '呼吸律动',
  },
  [LightEffectMode.BreathingRhythm_nd68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '呼吸律动_nd68',
  },
  [LightEffectMode.SaturatedStyle]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '饱和风采',
  },
  [LightEffectMode.BrightBeauty]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '亮度之美',
  },
  [LightEffectMode.SaturatedWindmill]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '饱和风车',
  },
  [LightEffectMode.BrightWindmill]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '亮度风车',
  },
  [LightEffectMode.SaturatedSpiral]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '饱和螺旋',
  },
  [LightEffectMode.BrightSpiral]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '亮度螺旋',
  },
  [LightEffectMode.AllCycle]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '循环所有',
  },
  [LightEffectMode.HorizontalCycle]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '左右循环',
  },
  [LightEffectMode.HorizontalCycle_nd68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '左右循环',
  },
  [LightEffectMode.HorizontalCycle_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.left_jtv2, LightDirectionType.right_jtv2],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '左右循环',
  },
  [LightEffectMode.HorizontalCycle_White]: {
    LightColor: [],
    LightDirection: [LightDirectionType.left, LightDirectionType.right],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '左右循环_White',
  },
  [LightEffectMode.VerticalCycle]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '上下循环',
  },
  [LightEffectMode.RainbowCluster]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹簇辉',
  },
  [LightEffectMode.RainbowCluster_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.clockwise_jtv2, LightDirectionType.counterclockwise_jtv2],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹簇辉',
  },
  [LightEffectMode.InnerOuterCycle]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '外内循环',
  },
  [LightEffectMode.BidirectionalCycle]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '双向循环',
  },
  [LightEffectMode.WindmillCycle]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '风车循环',
  },
  [LightEffectMode.SpiralCycle]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '螺旋循环',
  },
  [LightEffectMode.SpiralCycle_mg63]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '螺旋循环',
  },
  [LightEffectMode.DoubleBeacon]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '双信标',
  },
  [LightEffectMode.DoubleBeacon_White]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '双信标',
  },
  [LightEffectMode.RainbowBeacon]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹信标',
  },
  [LightEffectMode.RainbowBeacon_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹信标',
  },
  [LightEffectMode.RainbowWindmill]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹风车',
  },
  [LightEffectMode.Raindrop]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '雨滴',
  },
  [LightEffectMode.CandyRaindrop]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '糖果雨滴',
  },
  [LightEffectMode.CandyRaindrop_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '糖果雨滴',
  },
  [LightEffectMode.HueBreathing]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '色调呼吸',
  },
  [LightEffectMode.HueBreathing_mg63]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '色调呼吸',
  },
  [LightEffectMode.HuePendulum]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '色调摆钟',
  },
  [LightEffectMode.HueWave]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '色调波动',
  },
  [LightEffectMode.HueWave_nd68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '色调波动_nd68',
  },
  [LightEffectMode.HueWave_1]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.right, LightDirectionType.left],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '色调波动_nd68',
  },
  [LightEffectMode.PixelRain]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '像素雨',
  },
  [LightEffectMode.PixelFlow]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '像素流',
  },
  [LightEffectMode.PixelFlow_nd68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '像素流',
  },
  [LightEffectMode.PixelFractal]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '像素分形',
  },
  [LightEffectMode.TypingHeatmap]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '打字热图',
  },
  [LightEffectMode.SimpleResponse]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '简单响应',
  },
  [LightEffectMode.GeneralResponse]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '一般响应',
  },
  [LightEffectMode.WideResponse]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '宽响应',
  },
  [LightEffectMode.MultiWideResponse]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '多宽响应',
  },
  [LightEffectMode.CrossResponse]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '十字响应',
  },
  [LightEffectMode.MultiCross]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '多十字',
  },
  [LightEffectMode.CenterResponse]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '中心响应',
  },
  [LightEffectMode.MultiCenter]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '多中心',
  },
  [LightEffectMode.Splash]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '飞溅',
  },
  [LightEffectMode.MultiSplash]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '多重飞溅',
  },
  [LightEffectMode.FastRainbowDream_1]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: false,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '梦幻彩虹_1',
  },
  [LightEffectMode.Static_1]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '常亮_1',
  },
  [LightEffectMode.Static_2]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '常亮_2',
  },
  [LightEffectMode.Static_pro]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '常亮_pro',
  },
  [LightEffectMode.Neon_1]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '霓虹_1',
  },
  [LightEffectMode.Wave]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [LightDirectionType.up, LightDirectionType.down, LightDirectionType.left, LightDirectionType.right, LightDirectionType.inner, LightDirectionType.outer],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '波浪',
  },
  [LightEffectMode.Wave_nd68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.up, LightDirectionType.down, LightDirectionType.left, LightDirectionType.right],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '波浪_nd68',
  },
  [LightEffectMode.Starry_1]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '繁星_1',
  },
  [LightEffectMode.Radar]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '雷达',
  },
  [LightEffectMode.HorseRace]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '跑马',
  },
  [LightEffectMode.HorseRace_nd68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '跑马_nd68',
  },
  [LightEffectMode.Ripple]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '涟漪',
  },
  [LightEffectMode.MultiLineRace]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '多行跑马',
  },
  [LightEffectMode.Laser]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [LightDirectionType.inner, LightDirectionType.outer],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '激光',
  },
  [LightEffectMode.RippleAutoPlay]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '自动播放涟漪',
  },
  [LightEffectMode.ClickHighlight]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '单击亮',
  },
  [LightEffectMode.ClickHighlight_nd68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '单击亮_nd68',
  },
  [LightEffectMode.ClickHighlight_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.REACT,
    imageName: '单击亮_nd68',
  },
  [LightEffectMode.CrossCursor]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '十字光标',
  },
  [LightEffectMode.Fireworks]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '烟花',
  },
  [LightEffectMode.KeystrokeRate]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [LightDirectionType.up, LightDirectionType.down],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '按键速率响应',
  },
  [LightEffectMode.CustomMode]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '客制化模式',
  },
  [LightEffectMode.SixLineRace]: {
    LightColor: [LightColorType.foreground, LightColorType.background],
    LightDirection: [LightDirectionType.left, LightDirectionType.right],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '六行跑马',
  },
  [LightEffectMode.MusicRhythm]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.MUSIC,
    imageName: '音乐律动',
  },
  [LightEffectMode.StaticBright]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '静态恒亮',
  },
  [LightEffectMode.DynamicBreathing]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '动态呼吸',
  },
  [LightEffectMode.SpectrumCycle]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '光谱循环',
  },
  [LightEffectMode.StaticBright_White]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '静态恒亮_White',
  },
  //   '光谱循环': 0x04,
  [LightEffectMode.Wave_2]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '波浪_2',
  },
  [LightEffectMode.Wave_jingtaiV2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.left, LightDirectionType.right],
    isNeon: true,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '波浪_jtv2',
  },
  [LightEffectMode.Wave_mg63]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.left, LightDirectionType.right],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '波浪_mg63',
  },
  [LightEffectMode.Prosperity_1]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '花开富贵_1',
  },
  [LightEffectMode.PixelFlow_1]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '像素流_1',
  },
  [LightEffectMode.SineWave_1]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '正弦光波_1',
  },
  [LightEffectMode.SineWave_mg63]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '正弦光波',
  },
  [LightEffectMode.RainbowDream_2]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '梦幻彩虹_2',
  },
  [LightEffectMode.RainbowDream_mg63]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '梦幻彩虹',
  },
  [LightEffectMode.RainWalk_1]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '雨中散步_1',
  },
  [LightEffectMode.SpinningWindmill_1]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '旋转风车_1',
  },
  [LightEffectMode.SpinningWindmill_nd68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '旋转风车_nd68',
  },
  [LightEffectMode.SpinningWindmill_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [LightDirectionType.clockwise_jtv2, LightDirectionType.counterclockwise_jtv2],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '旋转风车_jtv2',
  },
  [LightEffectMode.SpinningWindmill_white]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise_jtv2, LightDirectionType.counterclockwise_jtv2],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '旋转风车_jtv2',
  },
  [LightEffectMode.StarryNight_1]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '繁星点点_1',
  },
  [LightEffectMode.RainbowWheel_1]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹轮盘_1',
  },
  [LightEffectMode.WaveMotion_1]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '随波逐流_1',
  },
  [LightEffectMode.SevenColorWaterfall_1]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '七彩瀑布_1',
  },
  [LightEffectMode.Starry_2]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '繁星_2',
  },
  [LightEffectMode.Scanning_1]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '左右扫描_1',
  },
  [LightEffectMode.Scanning_2]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '左右扫描_1',
  },
  [LightEffectMode.Scanning_mg63]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '左右扫描',
  },
  [LightEffectMode.Collision_2]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '来回碰撞_2',
  },
  [LightEffectMode.SaturatedStyle_pro]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '波浪_pro',
  },
  [LightEffectMode.BreathingRhythm_pro]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '呼吸律动_pro',
  },
  [LightEffectMode.BreathingRhythm_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '呼吸律动_jtv2',
  },
  [LightEffectMode.BreathingRhythm_mg63]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '呼吸律动_mg63',
  },
  [LightEffectMode.RainbowCluster_pro]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹簇辉_pro',
  },
  [LightEffectMode.RainbowBeacon_pro]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹信标_pro',
  },
  [LightEffectMode.HorizontalCycle_pro]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '左右循环_pro',
  },
  [LightEffectMode.CandyRaindrop_pro]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '糖果雨滴_pro',
  },
  [LightEffectMode.CandyRaindrop_huochairen]: {
    LightColor: [],
    LightDirection: [LightDirectionType.up_1, LightDirectionType.down_2],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '糖果雨滴_pro',
  },
  [LightEffectMode.ClickHighlight_pro]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '单击亮_pro',
  },
  [LightEffectMode.xx8]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '来回碰撞_2',
  },
  [LightEffectMode.xx9]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '来回碰撞_2',
  },
  [LightEffectMode.KeyRipple_pro]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '按键涟漪_pro',
  },
  [LightEffectMode.KeyRipple_mg63]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '按键涟漪_pro',
  },
  [LightEffectMode.ShadowChase_pro]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '烟花_pro',
  },
  [LightEffectMode.ShadowChase_jtv2]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '烟花',
  },
  [LightEffectMode.InstantFlash_pro]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.REACT,
    imageName: '一触即发_pro',
  },
  [LightEffectMode.SideStatic]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.Side,
    imageName: '常亮',
  },
  [LightEffectMode.SideFleeting]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '流光',
  },
  [LightEffectMode.SideFleeting_RG68_1]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '流光',
  },
  [LightEffectMode.SideSpectrumCycle]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '光谱循环',
  },
  [LightEffectMode.SideBreathing]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '呼吸',
  },
  [LightEffectMode.SideWave]: {
    LightColor: [],
    LightDirection: [LightDirectionType.clockwise, LightDirectionType.counterclockwise],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '波浪',
  },
  [LightEffectMode.SideBreathing_RA68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '呼吸',
  },
  [LightEffectMode.SideBreathing_RA68_1]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '呼吸',
  },
  [LightEffectMode.SideStatic_RA68_1]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '呼吸',
  },
  [LightEffectMode.SideWave_RA68]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '波浪',
  },
  [LightEffectMode.SideWave_RA68_1]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '波浪',
  },
  [LightEffectMode.SideClose]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: false,
    isSpeed: false,
    lightEffectType: LightModeType.Side,
    imageName: '关闭',
  },
  [LightEffectMode.SideNeon]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '霓虹',
  },
  [LightEffectMode.SideHorseRace]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: true,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.Side,
    imageName: '跑马',
  },
  [LightEffectMode.SideCustom]: {
    LightColor: [LightColorType.foreground],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.Side,
    imageName: '自定义',
  },
  [LightEffectMode.SaturatedStyle_FE87]: {
    LightColor: [],
    LightDirection: [LightDirectionType.left, LightDirectionType.right],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '波浪_pro',
  },
  [LightEffectMode.Prosperity_FE87]: {
    LightColor: [],
    LightDirection: [LightDirectionType.inner_jtv2, LightDirectionType.outer_jtv2],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '花开富贵',
  },
  [LightEffectMode.Prosperity_mg63]: {
    LightColor: [],
    LightDirection: [LightDirectionType.inner_jtv2, LightDirectionType.outer_jtv2],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '花开富贵',
  },
  [LightEffectMode.Wave_White]: {
    LightColor: [],
    LightDirection: [LightDirectionType.left, LightDirectionType.right],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '波浪',
  },
  [LightEffectMode.RainCurtain_White]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '雨落珠帘',
  },
  [LightEffectMode.RainbowBeacon_White]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: true,
    lightEffectType: LightModeType.RGB,
    imageName: '彩虹信标',
  },
  [LightEffectMode.Fleeting_White]: {
    LightColor: [],
    LightDirection: [],
    isNeon: false,
    isBrightness: true,
    isSpeed: false,
    lightEffectType: LightModeType.RGB,
    imageName: '流光',
  },
}
